export default "__VITE_ASSET__D2NA6ZvU__"